<template>
  <b-modal id="confirmOrganizationDelete"  ref="confirmOrganizationDelete" no-stacking>
    <template slot="modal-title">{{ $t('confirmationTitle') }}</template>
    <p>{{ $t('confirmDeleteOrganization') }}</p>
    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" @click="deleteOrganization">{{ $t('delete') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" v-on:click="cancel">{{ $t('cancel') }}</b-button>
    </div>
  </b-modal>
</template>

<script>
  import OrganizationService from '../../services/OrganizationService'

  export default {
    name: "DeleteOrganizationModal",
    methods: {
      deleteOrganization () {
        OrganizationService.deleteOrganization(this.$route.params.id)
          .then(() => {
            this.$router.go(-1)
          })
      },
      cancel () {
        this.$bvModal.hide('confirmOrganizationDelete')
      }
    }
  }
</script>